module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.props) ? _c('footer', {
    staticClass: "site-footer",
    attrs: {
      "id": "colophon"
    }
  }, [(_vm.props.acf.footerheading) ? _c('h2', {
    staticClass: "heading",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.footerheading)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "map-wrapper"
  }, [_c('div', {
    staticClass: "map-background"
  }, [_c('div', {
    staticClass: "custom-map",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.mapbackgroundimage + ')'
    }),
    attrs: {
      "id": "map"
    }
  })]), _vm._m(0)]), _c('div', {
    staticClass: "contact-wrapper"
  }, [(_vm.props.acf.formheading) ? _c('h4', {
    staticClass: "mobile-view",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.formheading)
    }
  }) : _vm._e(), _c('div', {
    staticClass: "contact-info"
  }, [_c('div', {
    attrs: {
      "itemscope": "",
      "itemtype": "http://schema.org/Person"
    }
  }, [_c('div', {
    attrs: {
      "itemprop": "address",
      "itemscope": "",
      "itemtype": "http://schema.org/PostalAddress"
    }
  }, [_c('h4', [(_vm.props.acf.doctername) ? _c('span', {
    attrs: {
      "itemprop": "name"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.doctername)
    }
  }) : _vm._e()]), _c('div', {
    staticClass: "contact-address"
  }, [(_vm.props.acf.streetaddress) ? _c('span', {
    staticClass: "street-address-block",
    attrs: {
      "itemprop": "streetAddress"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.streetaddress)
    }
  }) : _vm._e(), (_vm.props.acf.localityaddress) ? _c('span', {
    attrs: {
      "itemprop": "addressLocality"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.localityaddress)
    }
  }) : _vm._e(), (_vm.props.acf.regionaddress) ? _c('span', {
    attrs: {
      "itemprop": "addressRegion"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.regionaddress)
    }
  }) : _vm._e(), (_vm.props.acf.postalcode) ? _c('span', {
    attrs: {
      "itemprop": "postalCode"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.postalcode)
    }
  }) : _vm._e()]), _c('aside', [(_vm.props.acf.siteemaild) ? _c('a', {
    attrs: {
      "href": "mailto:" + _vm.props.acf.siteemaild,
      "itemprop": "email"
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.siteemaild)
    }
  })]) : _vm._e(), (_vm.props.acf.sitephonenumber) ? _c('a', {
    attrs: {
      "href": "tel:" + _vm.props.acf.sitephonenumber
    }
  }, [_c('span', {
    attrs: {
      "itemprop": "telephone"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.sitephonenumber)
    }
  })]) : _vm._e()])])])]), _c('div', {
    staticClass: "connect-us"
  }, [(_vm.props.acf.formheading) ? _c('h4', {
    staticClass: "desktop-view",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.formheading)
    }
  }) : _vm._e(), (_vm.props.acf.firstformheading) ? _c('b-button', {
    staticClass: "modal-trigger",
    attrs: {
      "id": "contactUsFormBtn"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.firstformheading)
    },
    on: {
      "click": function($event) {
        _vm.$bvModal.show('contactUsForm')
      }
    }
  }) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "contactUsForm",
      "hide-footer": "",
      "title": "Send Us A Message!"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('ContactForm')], 1)]), (_vm.props.acf.secondformheading) ? _c('b-button', {
    staticClass: "modal-trigger",
    attrs: {
      "id": "requestAppointmentBtn"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.secondformheading)
    },
    on: {
      "click": function($event) {
        _vm.$bvModal.show('requestAppointment')
      }
    }
  }) : _vm._e(), _c('b-modal', {
    attrs: {
      "id": "requestAppointment",
      "hide-footer": "",
      "title": "Request An Appointment"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('AppointmentForm')], 1)])], 1), _c('div', {
    staticClass: "copyright-wrapper"
  }, [(_vm.props.acf.sitecopyright) ? _c('div', {
    staticClass: "copyright",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.sitecopyright)
    }
  }) : _vm._e(), (_vm.props.acf.siteauthority) ? _c('div', {
    staticClass: "auuthority",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.siteauthority)
    }
  }) : _vm._e()])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-map-location-zoomed"
  }, [_c('div', {
    staticClass: "custom-map-location-button"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-49d849f4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 801
// module chunks = 1